import { Route, Switch, useLocation } from "react-router-dom";

import { DetailedInvestorCart } from "./InvestorCart";
import { Fragment, useEffect, useState } from "react";
import {
  Switch as SwitchTransaction,
  Redemption,
  STP,
  SWP,
} from "./CommercialTransactions";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../store/hooks";
import { getCartItemsList } from "../../../store/actions";
import { getInvestorDetailsByPan } from "../../../store/actions/cart";
import { handleError } from "../../../utils/cart";
import AdditionalPurchase from "./CommercialTransactions/AdditionalPurchase";
import NewPurchase from "./CommercialTransactions/NewPurchase";
import Sip from "./CommercialTransactions/Sip";
import CommonBreadCrumb from "../breadCrumbs";

const CART_ROUTES = [
  { path: "/cart/investor-cart", component: DetailedInvestorCart },
  { path: "/cart/edit-transaction/stp", component: STP },

  { path: "/cart/edit-transaction/swp", component: SWP },

  { path: "/cart/edit-transaction/redemption", component: Redemption },
  { path: "/cart/edit-transaction/switch", component: SwitchTransaction },
  { path: "/cart/add-transaction/stp", component: STP },

  { path: "/cart/add-transaction/swp", component: SWP },

  { path: "/cart/edit-transaction/sip-existing", component: Sip },
  { path: "/cart/add-transaction/sip-existing", component: Sip },

  { path: "/cart/edit-transaction/sip-new", component: Sip },
  { path: "/cart/add-transaction/sip-new", component: Sip },

  { path: "/cart/add-transaction/redemption", component: Redemption },
  {
    path: "/cart/add-transaction/additional-purchase",
    component: AdditionalPurchase,
  },
  {
    path: "/cart/edit-transaction/additional-purchase",
    component: AdditionalPurchase,
  },
  { path: "/cart/add-transaction/switch", component: SwitchTransaction },
  {
    path: "/cart/add-transaction/new-purchase",
    component: NewPurchase,
  },
  {
    path: "/cart/edit-transaction/new-purchase",
    component: NewPurchase,
  },
];

const CartRouter = () => {
  const dispatch = useDispatch();
  const location = useLocation<{ pan: string }>();

  const { token: arnCode } = useAppSelector((state) => state.authReducer);
  const { cartItems } = useAppSelector((state) => state.cartReducer);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async function () {
      try {
        const { state } = location;
        if (!state || !state.pan) return;
        await getCartItemsList({ pan: state.pan, arnCode })(dispatch);
        await getInvestorDetailsByPan(state.pan)(dispatch);
      } catch (error) {
        handleError(error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [location, arnCode, dispatch]);

  const pan = cartItems?.[0]?.pan;

  return (
    <Fragment>
      <div
        className="table_border"
        style={{
          margin: "32px 48px",
        }}
      >
        <CommonBreadCrumb
          breadcrumbNameMap={breadCrumbMap}
          pathnames={location.pathname.split("/").filter(Boolean)}
          state={{ pan }}
        />
      </div>
      {!isLoading && cartItems.length ? (
        <Switch>
          {CART_ROUTES.map((routeProps, index) => (
            <Route {...routeProps} exact key={index} />
          ))}
        </Switch>
      ) : null}
    </Fragment>
  );
};

export default CartRouter;

const breadCrumbMap = {
  "/cart/investor-cart": { to: "/dashboard", title: "Investor-Cart" },
  "/cart/edit-transaction": {
    to: "/cart/investor-cart",
    title: "Edit-Transaction",
  },
  "/cart/add-transaction": {
    to: "/cart/investor-cart",
    title: "New-Transaction",
  },
  "/cart/edit-transaction/stp": { to: "/cart/investor-cart", title: "stp" },
  "/cart/edit-transaction/swp": { to: "/cart/investor-cart", title: "swp" },
  "/cart/edit-transaction/redemption": {
    to: "/cart/investor-cart",
    title: "redemption",
  },
  "/cart/edit-transaction/switch": {
    to: "/cart/investor-cart",
    title: "switch",
  },
  "/cart/add-transaction/stp": { to: "/cart/investor-cart", title: "stp" },
  "/cart/add-transaction/swp": { to: "/cart/investor-cart", title: "swp" },
  "/cart/edit-transaction/sip-existing": {
    to: "/cart/investor-cart",
    title: "sip-existing",
  },
  "/cart/add-transaction/sip-existing": {
    to: "/cart/investor-cart",
    title: "sip-existing",
  },
  "/cart/edit-transaction/sip-new": {
    to: "/cart/investor-cart",
    title: "sip-new",
  },
  "/cart/add-transaction/sip-new": {
    to: "/cart/investor-cart",
    title: "sip-new",
  },
  "/cart/add-transaction/redemption": {
    to: "/cart/investor-cart",
    title: "redemption",
  },
  "/cart/add-transaction/additional-purchase": {
    to: "/cart/investor-cart",
    title: "additional-purchase",
  },
  "/cart/edit-transaction/additional-purchase": {
    to: "/cart/investor-cart",
    title: "additional-purchase",
  },
  "/cart/add-transaction/switch": {
    to: "/cart/investor-cart",
    title: "switch",
  },
  "/cart/add-transaction/new-purchase": {
    to: "/cart/investor-cart",
    title: "new-purchase",
  },
  "/cart/edit-transaction/new-purchase": {
    to: "/cart/investor-cart",
    title: "new-purchase",
  },
};
